import { render, staticRenderFns } from "./price-history-chart.vue?vue&type=template&id=28a93dee&scoped=true"
import script from "./price-history-chart.vue?vue&type=script&lang=js"
export * from "./price-history-chart.vue?vue&type=script&lang=js"
import style0 from "./price-history-chart.vue?vue&type=style&index=0&id=28a93dee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a93dee",
  null
  
)

export default component.exports